import api from "./axios";

export const walletApi = {
  /* ===================== GET WALLET ===================== */
  getWallet: async () => {
    const res = await api.get("/user/wallet");
    return res.data;
  },

  /* ===================== KYC SUBMISSION ===================== */
  submitKyc: async ({
    accountHolderName,
    accountNumber,
    ifscCode,
    branchName,
    upiId,
    panNumber,
  }) => {
    const res = await api.post("/kyc/submit", {
      accountHolderName,
      accountNumber,
      ifscCode,
      branchName,
      upiId: upiId || null,
      panNumber: panNumber || null,
    });

    return res.data;
  },

  /* ===================== WITHDRAW REQUEST ===================== */
  withdrawRequest: async ({ requestedAmount }) => {
    if (!requestedAmount) {
      throw new Error("requestedAmount is required");
    }

    const res = await api.post("/withdrawals/request", {
      requestedAmount,
    });

    return res.data;
  },

  /* ===================== WITHDRAWAL HISTORY ===================== */
  getWithdrawalHistory: async () => {
    const res = await api.get("/withdrawals/history");
    return res.data;
  },

  /* ===================== CHECK WITHDRAW ELIGIBILITY ===================== */
  checkWithdrawEligibility: async () => {
    const res = await api.get("/withdrawals/check-eligibility");
    return res.data;
  },
};